import { gql } from '@apollo/client';

// 🎯 ELIMINADO: NEW_VEHICLE_OCCUPANT_ACCIDENT - Los ocupantes de accidentes ahora están en VehicleAccidentContext

export const NEW_VEHICLE_OCCUPANT_ACTION = gql`
  mutation CreateVehicleOccupantAction($input: NewVehicleOccupantAction!) {
    createVehicleOccupantAction(input: $input) {
      id
      userDriverIDs
      actionIDs
      vehicleIDs
    }
  }
`;

export const UPDATE_VEHICLE_OCCUPANT = gql`
  mutation UpdateVehicleOccupant($input: UpdateVehicleOccupantInput!) {
    updateVehicleOccupant(input: $input) {
      id
      numberOccupants
      vehicleIDs
      accidentIDs
    }
  }
`;

export const CREATE_NEW_VEHICLE = gql`
  mutation CreateVehicle($input: NewVehicle!) {
    createVehicle(input: $input) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      accidentIDs
      ownership
      usage
      parentVehicleIDs
      childVehicleIDs
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const FIND_OR_CREATE_VEHICLE_BY_PLATE = gql`
  mutation FindOrCreateVehicleByPlate($input: NewVehicle!) {
    findOrCreateVehicleByPlate(input: $input) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      accidentIDs
      ownership
      usage
      parentVehicleIDs
      childVehicleIDs
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const UPDATE_VEHICLE = gql`
  mutation UpdateVehicle($input: UpdateVehicle!) {
    updateVehicle(input: $input) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      accidentIDs
      parentVehicleIDs
      childVehicleIDs
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const UPDATE_VEHICLE_BY_PLATE = gql`
  mutation UpdateVehicleByPlate($input: UpdateVehicleByPlate!) {
    updateVehicleByPlate(input: $input) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      accidentIDs
      parentVehicleIDs
      childVehicleIDs
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const DELETE_ALL_VEHICLES = gql`
  mutation DeleteAllVehicles($accidentId: ID!) {
    deleteAllVehicles(accidentId: $accidentId) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      accidentIDs
      parentVehicleIDs
      childVehicleIDs
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const DELETE_MANY_VEHICLES = gql`
  mutation DeleteManyVehicles($ids: [ID!]!) {
    deleteManyVehicles(ids: $ids) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      accidentIDs
      parentVehicleIDs
      childVehicleIDs
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const DELETE_MANY_VEHICLES_BY_PLATES = gql`
  mutation DeleteManyVehiclesByPlates($plates: [String!]!) {
    deleteManyVehiclesByPlates(plates: $plates) {
      id
      insurance
      plate
      model
      color
      category
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      accidentIDs
      parentVehicleIDs
      childVehicleIDs
      # 🎯 ELIMINADO: vehicleOccupantIDs - Los ocupantes ahora están en VehicleAccidentContext
      vehicleCategoryIDs
      concessionIDs
      teamIDs
    }
  }
`;

export const DELETE_MANY_VEHICLE_OCCUPANTS = gql`
  mutation DeleteManyVehicleOccupants($ids: [ID!]!) {
    deleteManyVehicleOccupantsAction(ids: $ids) {
      id
      numberOccupants
      userDriverIDs
      actionIDs
      accidentIDs
      vehicleIDs
    }
  }
`;

export const CREATE_VEHICLE_OCCUPANT = gql`
  mutation CreateVehicleOccupant($input: NewVehicleOccupantAction!) {
    createVehicleOccupantAction(input: $input) {
      id
      unit
      numberOccupants
      userDriverIDs
      actionIDs
      vehicleIDs
    }
  }
`;

export const UPDATE_VEHICLE_OCCUPANT_ACTION = gql`
  mutation UpdateVehicleOccupantAction(
    $input: UpdateVehicleOccupantActionInput!
  ) {
    updateVehicleOccupantAction(input: $input) {
      id
      unit
      numberOccupants
      userDriverIDs
      actionIDs
      vehicleIDs
    }
  }
`;

export const DELETE_VEHICLE_OCCUPANT = gql`
  mutation DeleteVehicleOccupant($id: ID!) {
    deleteVehicleOccupantAction(id: $id) {
      id
      numberOccupants
      userDriverIDs
      actionIDs
      vehicleIDs
    }
  }
`;

export const CREATE_MULTIPLE_VEHICLE_ACCIDENT_CONTEXTS = gql`
  mutation CreateMultipleVehicleAccidentContexts(
    $input: CreateMultipleVehicleAccidentContextsInput!
  ) {
    createMultipleVehicleAccidentContexts(input: $input) {
      id
      vehicleId
      accidentId
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      numberOccupants
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;

export const SET_TRAILER_RELATIONSHIP_IN_ACCIDENT = gql`
  mutation UpdateTrailerRelationships(
    $input: UpdateTrailerRelationshipsInput!
  ) {
    updateTrailerRelationships(input: $input) {
      id
      vehicleId
      accidentId
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;

export const CREATE_VEHICLE_ACCIDENT_CONTEXT = gql`
  mutation CreateVehicleAccidentContext(
    $input: CreateVehicleAccidentContextInput!
  ) {
    createVehicleAccidentContext(input: $input) {
      id
      vehicleId
      accidentId
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      numberOccupants
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;

export const FIND_OR_CREATE_VEHICLE_ACCIDENT_CONTEXT = gql`
  mutation FindOrCreateVehicleAccidentContext(
    $input: CreateVehicleAccidentContextInput!
  ) {
    findOrCreateVehicleAccidentContext(input: $input) {
      id
      vehicleId
      accidentId
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      numberOccupants
      parentVehicleContextId
      childVehicleContextIDs
      createdAt
    }
  }
`;

export const DELETE_VEHICLE_ACCIDENT_CONTEXT = gql`
  mutation DeleteVehicleAccidentContext($vehicleId: ID!, $accidentId: ID!) {
    deleteVehicleAccidentContext(
      vehicleId: $vehicleId
      accidentId: $accidentId
    ) {
      id
      vehicleId
      accidentId
      plate
    }
  }
`;

export const DELETE_ALL_VEHICLE_CONTEXTS_BY_ACCIDENT = gql`
  mutation DeleteAllVehicleContextsByAccident($accidentId: ID!) {
    deleteAllVehicleContextsByAccident(accidentId: $accidentId)
  }
`;

// 🎯 NUEVA MUTATION: Actualizar ocupantes en contexto de accidente
export const UPDATE_VEHICLE_ACCIDENT_CONTEXT_OCCUPANTS = gql`
  mutation UpdateVehicleAccidentContextOccupants(
    $input: UpdateVehicleAccidentContextOccupantsInput!
  ) {
    updateVehicleAccidentContextOccupants(input: $input) {
      id
      vehicleId
      accidentId
      numberOccupants
      plate
      model
      color
      category
      insurance
      policyNumber
      isTrailer
      isActive
      ownership
      usage
      createdAt
    }
  }
`;
